/**
切换资源，提供资源选择，资源上传等功能
*/
<!-- 
  接收参数
  url [ String ] 表示资源路径
  multiple [ Boolean ] 表示是否支持多选
  fileType [ Number | string ] 表示文件类型
  defaultCover [ String ] 当资源类型不是图片时给的默认封面图
 -->
<template>
  <div class="image-select-wrapper">
    <div class="image-select-l">
      <div class="component-image-select" @click="showSelector=true">
          <file-selector fileType="image" v-if="showSelector" @finish="changeImage"></file-selector>

        <el-image v-show="url" style="width: 100px; height: 100px;margin: 0px;" fit="contain" :src="url"></el-image>
        
        <div class="image-preview-null" v-show="!url">
          <p><i class="el-icon-plus"></i></p>
          <p>选择资源</p>
        </div>
      </div>
    </div>
    <!-- <div class="image-select-r">
      <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入资源地址"
              v-model="tempValue">
      </el-input>
    </div> -->
  </div>
</template>

<script>
	import $bus from '@client/eventBus'
  import {mapState,mapGetters} from 'vuex'
import fileSelector from './file-selector.vue'
	export default {
  components: { fileSelector },
		props: {
			url: String,
            multiple:Boolean,
            fileType:[Number,String],
            defaultCover:[String]
		},
		data() {
			return {
				// 唯一得id用于选择图片后事件通知
				//selectId: +new Date(),
				tempValue: '',
                showSelector: false
			}
		},
		created() {
			//$bus.$on('select-image', this.changeIamge)
			//this.tempValue = this.url;
		},
		watch: {
			// url(val) {
			// 	this.tempValue = val;
			// },
			// tempValue(val) {
			// 	this.changeIamge(this.selectId, val);
			// },
      // activeElement:{
      //   deep:true,
      //   handler:function(val){
      //     if(val != undefined){
      //       this.$set(this,'fileType',this.elFileType[val.elName] )
      //     }
      //   }
      // }
		},
		methods: {
			changeImage(file) {
                this.showSelector = false;

                if (file) {
                    this.$emit('update:url', file.file_url)
                    this.$emit('change', file.file_url)
                }
				
			},
			
		},
    computed:{
      ...mapGetters([
				'activeElement',
      ]),
      // fileType(){
      //   return this.elFileType[this.activeElement.elName]
      // }
    }
	}
</script>

<style lang="scss" scoped>
  .component-image-select {
    width: 100px;
    height: 100px;
    border: 1px dashed $primary;
    border-radius: 3px;
    margin-bottom: 18px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.28s;
    position: relative;
    background: #eee 50%/contain no-repeat;
    justify-content:center;
    align-items:center;
    display: flex;
    &:hover {
      color: $primary;
    }
    img{
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }
    p{
      line-height: 1;
      padding-bottom: 10px;
    }
  }
  .image-preview-null {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding-top: 25px;
    background: rgba(0, 0, 0, 0.2);
  }
  .image-select-wrapper{
    display: flex;
    .image-select-l{
      width: 108px;
    }
    .image-select-r{
      flex: 1;
    }
  }
</style>
